export default {"src":"/org/_next/static/media/info.3959e507.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};